import api from 'config/axios';
import AppService from 'common/app-service';
import { ICTeEligibilityCriterias, IFreezeSettings, IUpdateCTeEligibilityCriterias, IUpdateFreezeSettings } from 'common/system.interface';
import { defaultTimeFormat } from 'utils/date';

export default class SystemService extends AppService {
  constructor() {
    super('system', api);
  }

  async getFreezeSettings(): Promise<IFreezeSettings> {
    const response = await this.api.get(this.root('freeze'));

    return response.data;
  }

  async postFreezeSettings({ dailyTimeLimit }: IUpdateFreezeSettings): Promise<IFreezeSettings> {
    const response = await this.api.post(this.root('freeze'), {
      dailyTimeLimit: dailyTimeLimit.toFormat(defaultTimeFormat),
    });

    return response.data;
  }

  async getFreezeStatus(): Promise<{
    isWorkday: boolean;
    dailyTimeLimit: string;
  }> {
    const response = await this.api.get(this.root('workday'));

    return response.data;
  }

  async saveCTesEligibilityCriterias(payload: IUpdateCTeEligibilityCriterias): Promise<ICTeEligibilityCriterias> {
    const response = await this.api.post(this.root('cte-processor/criterias'), {
      ...payload,
    });

    return response.data;
  }

  async getCTesEligibilityCriterias(): Promise<ICTeEligibilityCriterias> {
    const response = await this.api.get(this.root('cte-processor/criterias'));

    return response.data;
  }

  async validateDueDate(date: string): Promise<{ hasBeenRecalculated: boolean; nextWorkday: string; diffDays: number }> {
    const response = await this.api.get(this.root(`workday?date=${date}`));

    return response.data;
  }
}
